export const getSpinnerStyles = () => ({
  spinnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    '& .spinner': {
      width: 20,
      height: 20,
      overflow: 'hidden',
    },
    '& span.message': {
      flex: '1 0 0',
      color: '#605E5C',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '22px',
      marginLeft: 8,
    },
  },
});
